import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const TossPaymentMob = () => {
  return <CommonProcess />;
};

export default TossPaymentMob;
